<template>
	<div style="background-color:#fffcf7;" class="container">
		<headMenu />
		<div class="w-100 p-3 bg-ingo">
			<div class="text-center">
				<img :src="require('../../../assets/img/Shape_Title.svg')" />
				<p class="bMikhak text-center text-success" style="font-size: 24px;">
					شرایط حفظ حریم خصوصی و قوانین و مقررات ایزی تیک
				</p>
			</div>
			<div class="row mt-3">
				<p class="text-justify">
					<b>اطلاعات عمومی:</b>
					اطلاعات حاضر در اینجا درباره‌ی اطلاعات خصوصی کاربرانی می‌باشد که از سامانه‌ی ایزی تیک برای خدمات پشتیبانی از کاربران و تیکتینگ استفاده می‌کنند و این اطلاعات برای شناسایی کاربران ایزی تیک می‌باشد. اطلاعات کاربران ایزی تیک شامل شماره موبایل، نام و نام خانوادگی، و سایر اطلاعات می‌باشد که بصورت عمومی منتشر نخواهند شد. این اطلاعات ممکن است برای استفاده از سامانه‌ی ایزی تیک از کاربران خواسته شود. این اطلاعات فقط برای خدمات درخواستی کاربر مورد استفاده قرار خواهند گرفت. این اطلاعات کاملاً محرمانه است مگر در مواردی که با دستور قضایی در اختیار آن مقام قرار گیرد. 
				</p>
				<p class="text-justify">
					<b>کوکی‌ها:</b>
					کاربر باید آگاه باشد که اطلاعات و داده‌ها ممکن است به ‌صورت خودکار و از طریق استفاده از «کوکی‌ها» جمع‌آوری شود. «کوکی‌ها» فایل‌های متنی کوچکی هستند که یک وب ‌سایت می‌تواند از آن‌ها برای تشخیص کاربران مراجعه‌ کننده مجدد، فراهم کردن امکان دیدبانی رفتار، جمع‌آوری اطلاعات کلی به‌منظور ارتقای وب‌ سایت و مشخص کردن سمت ‌و سوی تبلیغات استفاده کند. کوکی‌ها به سیستم کاربر ملحق نشده و به فایل‌های شما صدمه نمی‌رسانند. اگر کاربر مایل نیست تا اطلاعاتش از طریق استفاده از کوکی‌ها جمع‌آوری شود، در اغلب مرورگرها می‌توان به روشی آسان ویژگی کوکی را قبول و یا رد کرد. 
				</p>
				<p class="text-justify">
					<b>حذف کاربر یا تغییر اطلاعات:</b>
					کاربر می‌تواند در هر بار استفاده از خدمات، اطلاعات خود را ویرایش نماید. همچنین حذف حساب کاربری، از طریق تماس با پشتیبانی امکان پذیر می‌باشد. 
				</p>
				<p class="text-justify">
					<b>قوانین و مقررات:</b>
					هر گونه استفاده از خدمات ایزی تیک به معنی پذیرفتن شرایط مندرج در سایت ایزی تیک می‌باشد. سایت ایزی تیک هیچ توافقی با اساتید خارج از این شرایط ندارد. شرایط و قوانین زیر مربوط به تمام اساتیدی است که به هر شکلی با ایزی تیک همکاری و از خدمات آن استفاده می‌کنند. کاربران فعال در ایزی تیک با مسئولیت خود از خدمات آن برای کاربران خود استفاده می‌کنند و ایزی تیک هیچ تعهد یا مسئولیتی در قبال خسارات مستقیم، اتفاقی، تبعی، غیرمستقیم و کیفری، ناشی از ارتباط بین کاربران و شرکتهای استفاده کننده نخواهد داشت. به عبارتی ایزی تیک صرفا ارتباط بین شرکت و کاربر را برای تیکت فراهم می‌کند و به هیچ عنوان تضمینی در مورد نحوه ارائه خدمات در تیکت های ارسالی و دریافتی نمی‌تواند ارائه نماید.
 اکیدا لازم و ضروری است که شرکت بهره بردار در خصوص تعهدات خود نسبت به کاربر پایبند باشد. و درصورت مشاهده تخلف یا تلاش برای سوءاستفاده از تیکتینگ، حق انسداد سامانه و لغو امتیاز برای ایزی تیک محفوظ است. ایزی تیک می‌تواند در هر زمان به تشخیص خود شرایط تضمین‌ها را تغییر داده یا ارائه آن را متوقف کند. 

				</p>
				<br><br>
			</div>
			<footerPage />
		</div>
	</div>
</template>

<script>
	import footerPage from  "../../../UI/footer/footer.vue";
	import btn from  "../../../UI/button/btn.vue";
	import headMenu from  "../../../menu/headMenu.vue";
	import leftMenuPublic from  "../../../menu/leftMenuPublic.vue";
	import { indexFinder } from  "../../../assets/library/filter.js";


	export default {
			name: 'teachers_id',
		data(){
			return {
				imgurl: window.imgurl,
				baseurl: window.baseurl,
				flds: [],
				degrees: [],
				category: [],
				location: [],
				indexFinder : indexFinder,
				index_text : -1
			}
		},
		components: {
				btn,
				headMenu,
				footerPage,
				leftMenuPublic,
		},
			props: [],
		mounted(){
			this.$swal.close();
		},
		methods:{
				// *********************************************************************
		}
	}
</script>
<style>

</style>
